import React, { useState, useEffect } from "react";
import { FaTimes, FaPlus } from "react-icons/fa";
import axios from "axios";
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker";

const apiUrl = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");

const FamilyDependentPopup = ({ onUpdate }) => {
  const { userId } = useParams();
  const [dependentData, setDependentData] = useState([]);

  useEffect(() => {
    fetchDependentData();
  }, []);

  const fetchDependentData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/employees/dependent-info/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (Array.isArray(response.data.dependentInfo)) {
        setDependentData(response.data.dependentInfo);
        onUpdate(response.data.dependentInfo);
      } else {
        console.error('Fetched dependent data is not an array:', response.data);
      }
    } catch (error) {
      console.error('Error fetching dependent data:', error);
    }
  };

  const handleAddMore = () => {
    setDependentData((prevData) => [
      ...prevData,
      {
        name: "",
        relationship: "",
        gender: "",
        dateOfBirth: null, // Setting dateOfBirth as null initially
      },
    ]);
  };

  const handleRemove = (index) => {
    setDependentData((prevData) => {
      const updatedData = [...prevData];
      updatedData.splice(index, 1);
      return updatedData;
    });
  };

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...dependentData];
    list[index][name] = value;
    setDependentData(list);
  };

  const handleDateChange = (date, index) => {
    const list = [...dependentData];
    list[index].dateOfBirth = date;
    setDependentData(list);
  };

  const handleSave = () => {
    const requestData = {
      dependentInfo: dependentData.map((dependent) => {
        return {
          name: dependent.name,
          relationship: dependent.relationship,
          gender: dependent.gender,
          dateOfBirth: dependent.dateOfBirth,
        };
      }),
    };
  
    axios
      .post(`${apiUrl}/employees/updatedependent-info/${userId}`, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        fetchDependentData(); // Update the dependent data after saving
        console.log('Response from API:', response.data);
        alert('Data saved successfully!');
        onUpdate(dependentData);

      })
      .catch((error) => {
        console.error('Error while saving data:', error);
        alert('Failed to save data. Please try again.');
      });
  };
  

  return (
    <div id="family_dependent_popup" className="modal custom-modal fade" role="dialog">
  <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "60%" }}>
  <div className="modal-content h-100">
          <div className="modal-header">
            <h5 className="modal-title">Family Dependent Information</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"><FaTimes /></span>
            </button>
          </div>
          <div className="modal-body">
            <form>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Relationship</th>
                      <th>Gender</th>
                      <th>Date of Birth</th>
                      <th><FaPlus style={{ cursor: "pointer", fontSize: "18px" }} onClick={handleAddMore} /></th>
                    </tr>
                  </thead>
                  <tbody>
                    {dependentData.map((dependent, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="text"
                            name="name"
                            value={dependent.name}
                            onChange={(e) => handleInputChange(index, e)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="relationship"
                            value={dependent.relationship}
                            onChange={(e) => handleInputChange(index, e)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <select
                            name="gender"
                            value={dependent.gender}
                            onChange={(e) => handleInputChange(index, e)}
                            className="form-select form-select-sm" // Added form-select-sm class here
                            style={{ width: '100px' }} // Added inline s
                          >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                          </select>
                        </td>
                        <td>
                          <DatePicker
                            selected={dependent.dateOfBirth}
                            onChange={(date) => handleDateChange(date, index)}
                            className="form-control"
                            placeholderText="Select Date of Birth"
                            dateFormat="MM/dd/yyyy"
                          />
                        </td>
                        <td>
                          <FaTimes
                            style={{ cursor: "pointer" }}
                            onClick={() => handleRemove(index)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={handleSave}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDependentPopup;
